import { renderManaText } from '../cardStats/manaText';
import { buildEffectSummary, EFFECT_TYPE_META, effectTypeLabel } from './cardInfoModel';
import { Section, TagList } from './Section';

function ParsedClause({ clause }) {
    const results = clause.results || [];
    return (
        <li className="cardInfoClause">
            <p className="cardInfoQuote">&ldquo;{renderManaText(clause.rawText || clause.text || '')}&rdquo;</p>
            <TagList tags={buildEffectSummary(clause)} />
            {results.length > 0 && (
                <div className="cardInfoResults">
                    <p className="cardInfoResultsLabel">Results in</p>
                    <ul className="cardInfoClauses">
                        {results.map((result, idx) => (
                            <ParsedClause clause={result} key={result.id || idx} />
                        ))}
                    </ul>
                </div>
            )}
        </li>
    );
}

/**
 * The parse itself: every line of rules text, what kind of effect it is, and
 * the conditions and results the engine read out of it. This is the site's
 * "show the reasoning" surface, so it stays open rather than tucked away.
 */
export function CardEffects({ lines, loading }) {
    const parsed = Array.isArray(lines) ? lines : [];
    return (
        <Section
            title="How Commandersalt reads this card"
            hint="Each line of rules text, tagged by effect type with its parsed behavior."
        >
            {parsed.length === 0 ? (
                loading ? (
                    <p className="skeletonBlock cardInfoLineSkeleton">&nbsp;</p>
                ) : (
                    <p className="cardInfoEmpty">No parsed effects recorded for this card.</p>
                )
            ) : (
                <ol className="cardInfoLines">
                    {parsed.map((line, idx) => (
                        <li className="cardInfoLine" key={line.id || idx}>
                            <p className="cardInfoLineHead">
                                <span
                                    className={`cardInfoEffectType cardInfoEffectType--${
                                        EFFECT_TYPE_META[line.effectType]?.tone || 'gray'
                                    }`}
                                >
                                    {effectTypeLabel(line.effectType)}
                                </span>
                                <span className="cardInfoLineRaw">{renderManaText(line.raw || '')}</span>
                            </p>
                            <ul className="cardInfoClauses">
                                {(line.parts || []).map((part, partIdx) =>
                                    (part.conditions || []).map((condition, condIdx) => (
                                        <ParsedClause
                                            clause={condition}
                                            key={`${part.id || partIdx}::${condition.id || condIdx}`}
                                        />
                                    ))
                                )}
                            </ul>
                        </li>
                    ))}
                </ol>
            )}
        </Section>
    );
}
